/*Traduction avec i18n React*/
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from 'i18next-http-backend';

const version = "1.2.7"; // CHANGE THIS VERSION WHEN YOU UPDATE TRANSLATIONS FILES TO AVOID CACHE ISSUES

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: "en", // default language
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: `/locales/{{lng}}.json?v=${version}`, // add version to avoid cache
    },
  });

export default i18n;